import React from 'react';
import PropTypes from 'prop-types';
import {inject, observer} from 'mobx-react';
import {computed} from 'mobx';
import certificate from 'spa/images/icons/certificate_yellow.svg';
import language from 'spa/images/icons/language-yellow.svg';
import experience from 'spa/images/icons/experience-yellow.svg';
import RatingBadge from 'spa/Components/RatingBadge';

import {withI18n} from 'spa/Components/Context';

const TRAIT_SCORE_MINIMUM = 5;

@inject(({store: {workerLanguages}}) => ({
  workerLanguages,
}))
@observer
@withI18n
class ReferralTherapistCard extends React.Component {
  static propTypes = {
    suggestedWorker: PropTypes.object.isRequired,
    workerLanguages: PropTypes.shape({
      maybeLoadOne: PropTypes.func.isRequired,
      getOneInstance: PropTypes.func.isRequired,
    }).isRequired,
  }

  UNSAFE_componentWillMount() {
    this.props.workerLanguages.maybeLoadOne(this.props.suggestedWorker.id);
  }

  @computed get therapistTraits() {
    const {suggestedWorker} = this.props;
    if (!suggestedWorker || !suggestedWorker.traits) return null;
    if (Object.keys(suggestedWorker.traits).length === 0) return null;
    const validTraits = Object.keys(suggestedWorker.traits).filter(trait => (
      suggestedWorker.traits[trait].score &&
        parseInt(suggestedWorker.traits[trait].score, 10) >= TRAIT_SCORE_MINIMUM
    )).map(trait => (
      `${trait.charAt(0).toUpperCase()}${trait.slice(1)}`
    ));
    if (validTraits) return validTraits.join(', ');
    return null;
  }

  @computed get therapistLanguages() {
    const {workerLanguagesSearch} = this;
    if (!workerLanguagesSearch) {
      return null;
    }

    const spoken = Object.keys(workerLanguagesSearch).map(lang => (
      workerLanguagesSearch[lang].name
    ));

    if (spoken && spoken.length === 0) {
      return null;
    }

    return spoken && spoken.length && spoken.join(', ');
  }

  @computed get workerLanguagesSearch() {
    setTimeout(() => this.props.workerLanguages.maybeLoadOne(this.props.suggestedWorker.id), 0);
    return this.props.workerLanguages.getOneInstance(this.props.suggestedWorker.id);
  }

  render() {
    const therapist = this.props.suggestedWorker;
    const {therapistTraits, therapistLanguages} = this;
    const {i18n} = this.context;

    return (
      <div className="row referral-card">
        <img
          className="referral-card__image"
          src={`/api/workers/${therapist.id}/image/square?crop=fill&width=180&height=180`}
          width="71"
          height="71"
          alt=""
        />
        <div className="referral-card__content">
          <div className="referral-card__name">{therapist.name}</div>
          <div className="referral-card__rating"><RatingBadge rating={parseFloat(therapist.rating, 10)} /></div>
          <div className="referral-card__bio">{therapist.bioShort}</div>
          {therapistTraits && (
            <div className="referral-card__item">
              <img
                className="referral-card__icon"
                src={certificate}
                alt=""
              />
              <div>
                <p className="referral-card__item-title">{i18n._x('Ideal For', 'Referred Therapist card')}</p>
                <p className="referral-card__item-text">{therapistTraits}</p>
              </div>
            </div>
          )}
          {therapist.experience && (
            <div className="referral-card__item">
              <img
                className="referral-card__icon"
                src={experience}
                alt=""
              />
              <div>
                <p className="referral-card__item-title">{i18n._x('Experience', 'Referred Therapist card')}</p>
                <p className="referral-card__item-text">{therapist.experience === 1 ? `${therapist.experience} Year` : `${therapist.experience} Years`}</p>
              </div>
            </div>
          )}
          {therapistLanguages && (
            <div className="referral-card__item">
              <img
                className="referral-card__icon"
                src={language}
                alt=""
              />
              <div>
                <h5 className="referral-card__item-title">{i18n._x('Languages', 'Referred Therapist card')}</h5>
                <h4 className="referral-card__item-text">{therapistLanguages}</h4>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default ReferralTherapistCard;



// WEBPACK FOOTER //
// ./spa/Components/ReferralTherapistCard.jsx